import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext';

export default function PrivateRoutes() {
    const { user, isLoading } = useAuth();
    const login = localStorage.getItem("login") === "true" || !!user;

    if (isLoading) {
        return (
            <div className="loader-wrapper">
                <div className="loader">
                    <span></span><span></span><span></span><span></span><span></span>
                </div>
            </div>
        );
    }

    return login ? <Outlet /> : <Navigate to={`${process.env.PUBLIC_URL}/login`} />
}
